import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { PTHero } from '../components/pdo-threads/PTHero';
import { PTWhatIs } from '../components/pdo-threads/PTWhatIs';
import { PTVersatility } from '../components/pdo-threads/PTVersatility';
import { PTBenefits } from '../components/pdo-threads/PTBenefits';
import { PTHowItWorks } from '../components/pdo-threads/PTHowItWorks';
import { PTFAQ } from '../components/pdo-threads/PTFAQ';
import { PTWhyChoose } from '../components/pdo-threads/PTWhyChoose';
import { PTCTA } from '../components/pdo-threads/PTCTA';
export function PdoThreadsPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2588">
      <Navigation data-id="element-2589" />
      <main data-id="element-2590">
        <PTHero data-id="element-2591" />
        <PTWhatIs data-id="element-2592" />
        <PTVersatility data-id="element-2593" />
        <PTBenefits data-id="element-2594" />
        <PTHowItWorks data-id="element-2595" />
        <PTFAQ data-id="element-2596" />
        <PTWhyChoose data-id="element-2597" />
        <PTCTA data-id="element-2598" />
      </main>
      <Footer data-id="element-2599" />
    </div>;
}